export default "__VITE_ASSET__D8jpRKR2__"